module.exports = __webpack_public_path__ + "static/img/gpt75.360ecfc3.png";